import { useState } from 'react';
export const useCFField = (name, initialValue = '', hookOptions = {
    allowMultiple: false,
    options: [],
    required: false,
    validators: [],
}) => {
    const { allowMultiple, onChange, options, required, validators } = hookOptions;
    const [errors, setErrors] = useState(false);
    const [internalOptions, setOptions] = useState(options || []);
    const [validated, setValidated] = useState(false);
    const [validationState, setValidationState] = useState('default');
    const [value, setValue] = useState(initialValue);
    const onFieldChange = (value, payload) => {
        if (value)
            setValue(value);
        else
            setValue(allowMultiple ? [] : '');
        if (payload === null || payload === void 0 ? void 0 : payload.options)
            setOptions(payload === null || payload === void 0 ? void 0 : payload.options);
        else
            setOptions([]);
        if (onChange)
            onChange(value, payload);
    };
    const validate = () => {
        if ((!value || (value === null || value === void 0 ? void 0 : value.length) === 0) && required) {
            setValidationState('error');
            setValidated(false);
            setErrors(['This field is required']);
            return false;
        }
        if (!validators || validators.length === 0) {
            setValidationState('default');
            setValidated(false);
            setErrors(false);
            return null;
        }
        const newErrors = [];
        validators.forEach(([boolFn, err]) => {
            if (!boolFn(value))
                newErrors.push(err);
        });
        if (newErrors.length > 0) {
            setValidationState('error');
            setValidated(false);
            setErrors(newErrors);
            return false;
        }
        setValidationState('valid');
        setValidated(true);
        setErrors(false);
        return true;
    };
    return {
        allowMultiple,
        errors,
        name,
        onChange: onFieldChange,
        options: internalOptions,
        validate,
        validated,
        validationState,
        value,
    };
};
